<template>
  <div class="page-table scrollable">
    <el-table
        :data="collection"
        :row-style="{ 'max-height': '40px' }"
        ref="cTable"
        @select="handleRowSelection"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        @header-click="handleHeaderClick"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
          v-for="(col, idx) in columns"
          :key="idx"
          :type="col.datatype"
          :prop="col.name"
          :label="col.label ? col.label : col.name"
          :width="col.width"
          :min-width="col['min-width']"
          :sortable="col.sortable ? 'custom' : false"
          class-name="subtitle2"
      >
        <template slot-scope="scope">
          <div v-if="col.datatype === 'boolean'">
            <el-tag size="medium">{{ scope.row[col.name] ? 'Active' : 'Inactive' }}</el-tag>
          </div>

          <div v-else-if="col.datatype === 'datetime'">
            <time class="body1">{{ getFormatedDateTime(scope.row, col) }}</time>
          </div>

          <div v-else-if="col.datatype === 'objectpath' && !col.display">
            <span class="body1">{{ getObjectPathValue(scope.row, col.name) }}</span>
          </div>

          <div v-else-if="col.display === 'icon'">
            <span class="body1"> <i :class="getIcon(scope.row, col, col.displayKey).icon"></i> </span>
          </div>

          <div v-else-if="col.display === 'iconAndText'">
            <span class="body1" v-if="getIcon(scope.row, col, col.displayKey).iconDirection === 'right'">
              {{ getColorTagValue(scope.row, col, col.displayKey).display }}
              <i
                  class="display-inline-block"
                  :style="[
                  { color: getColorTagValue(scope.row, col, col.displayKey).color },
                  { background: getColorTagValue(scope.row, col, col.displayKey).color }
                ]"
                  :class="getIcon(scope.row, col, col.displayKey).icon"
              ></i>
            </span>
            <span class="body1" v-else>
              <i
                  class="display-inline-block"
                  :style="[
                  { color: getColorTagValue(scope.row, col, col.displayKey).color },
                  { background: getColorTagValue(scope.row, col, col.displayKey).color }
                ]"
                  :class="getIcon(scope.row, col, col.displayKey).icon"
              ></i>
              {{ getColorTagValue(scope.row, col, col.displayKey).display }}
            </span>
          </div>

          <div v-else-if="col.display === 'colorTag'">
            <el-tag
                size="small"
                :style="[
                { color: getColorTagValue(scope.row, col, col.displayKey).textColor },
                { 'border-color': getColorTagValue(scope.row, col, col.displayKey).textColor }
              ]"
                class="button2 capitalize-first-letter"
                :color="getColorTagValue(scope.row, col, col.displayKey).color"
            >{{ getColorTagValue(scope.row, col, col.displayKey).display }}
            </el-tag
            >
          </div>

          <div v-else-if="col.display === 'stateTag'">
            <state-tag :status="scope.row[col.name]" :class-list="'button2 capitalize-first-letter'"/>
          </div>

          <div v-else-if="col.display === 'link'">
            <router-link v-if="col.query" :to="{ name: col.pathTo, query: getQueryParamObject(scope.row, col) }">
              <a v-if="col.linkLabel">{{ getObjectPathValue(scope.row, col.linkLabel.labelName) }}</a>
              <a v-else>
                {{ col.datatype === 'objectpath' ? getObjectPathValue(scope.row, col.name) : scope.row[col.name] }}
              </a>
            </router-link>
            <router-link v-else :to="{ name: col.pathTo, params: getQueryParamObject(scope.row, col, 'params') }">
              <a v-if="col.linkLabel">{{ getObjectPathValue(scope.row, col.linkLabel.labelName) }}</a>
              <a v-else>
                {{ col.datatype === 'objectpath' ? getObjectPathValue(scope.row, col.name) : scope.row[col.name] }}
              </a>
            </router-link>
          </div>

          <div v-else-if="col.display === 'mitrelink'">
            <span class="value">
              <a :href="getObjectPathValue(scope.row, col.link)" target="_blank" rel="noreferrer"
              >{{ getObjectPathValue(scope.row, col.linkLabel.labelId) }}:
                {{ getObjectPathValue(scope.row, col.linkLabel.labelName) }}</a
              >
            </span>
          </div>

          <div v-else-if="col.display === 'popup'">
            <el-link @click="emitCallbackEvent('popup-click', scope.row, col.name)">{{
                col.datatype === 'objectpath' ? getObjectPathValue(scope.row, col.name) : scope.row[col.name]
              }}
            </el-link>
          </div>

          <div v-else-if="col.display === 'riskscore'">
            <span class="body1">
              <i class="color-block" :class="`${scope.row.riskLevel.level}-risk-color`"></i>
              <span class="body1">{{ scope.row[col.name] }}</span>
            </span>
          </div>

          <div v-else-if="col.display === 'switch'">
            <span class="body1">
              <el-switch
                  v-model="scope.row[col.name]"
                  :width="40"
                  :active-value="col.displayKey.active.key"
                  :inactive-value="col.displayKey.inactive.key"
                  :active-text="
                  getObjectPathValue(scope.row, col.name) === col.displayKey.active.key
                    ? col.displayKey.active.display
                    : col.displayKey.inactive.display
                "
                  :disabled="true"
              >
              </el-switch>
            </span>
          </div>
          <div v-else-if="col.display === 'component'">
            <span v-if="col.component === 'CyberKillChainTickChart'">
              <cyber-kill-chain-tick-chart
                  :chart-id="`${scope.$index}`"
                  :chart-data="getObjectPathValue(scope.row, col.name)"
                  :key="`${scope.$index}_${getObjectPathValue(scope.row, col.componentKey)}`"
              />
              <a :href="getObjectPathValue(scope.row, col.link)" target="_blank" rel="noreferrer" v-if="col.link">
                <span v-if="col.displayTextName">{{ getObjectPathValue(scope.row, col.displayTextName) }}</span>
              </a>
              <span v-else-if="col.displayTextName">{{ getObjectPathValue(scope.row, col.displayTextName) }}</span>
            </span>
            <span v-if="col.component === 'RecommendationProgress'">
              <recommendation-progress :row-data="scope.row"/>
            </span>
            <span v-if="col.component === 'PercentComplete'">
              <percent-complete
                  :completed="getObjectPathValue(scope.row, col.componentFields.completed)"
                  :total="getObjectPathValue(scope.row, col.componentFields.total)"
              />
            </span>
            <span v-if="col.component === 'UserButton'">
              <user-button
                  :classList="getObjectPathValue(scope.row, col.name).firstname ? 'shamrock-200' : ''"
                  :user="getObjectPathValue(scope.row, col.name)"
                  :key="`${scope.$index}_${getObjectPathValue(scope.row, col.componentKey)}`"
              />
              {{ getObjectPathValue(scope.row, col.name).fullname }}
            </span>
          </div>

          <div v-else-if="col.display === 'tag'">
            <el-tag size="medium" v-for="(item, idx) in scope.row[col.name]" :key="idx">{{ item }}</el-tag>
          </div>

          <span v-else-if="col.display === 'fingerprintLabel'" class="body1">
            {{ scope.row[col.display] }}
            <span
                v-if="scope.row[col.name]"
                class="display-inline-block icon-copy-to-clipboard cursor-pointer"
                @click="copyToClipboard(scope.row, col.name)"
            >
            </span>
          </span>

          <div v-else-if="col.datatype === 'array' || col.display === 'array'">
            <span v-for="(item, idx) in getObjectPathValue(scope.row, col.name)" :key="idx">
              {{ item }}
              <el-divider
                  v-if="idx !== getObjectPathValue(scope.row, col.name).length - 1"
                  direction="vertical"
              ></el-divider>
            </span>
          </div>

          <div v-else>
            <span class="body1">{{ scope.row[col.name] }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="prev, pager, next"
        :page-size="this.tableData.recordsPerPage"
        :total="this.tableData.totalRecords"
        :current-page="this.tableData.currentPage"
        prev-text="PREV"
        next-text="NEXT"
        hide-on-single-page
        style="text-align: center; padding-top: 20px"
        @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import StateTag from "@/components/button/StateTag.vue";

export default {
  name: 'MultiSelectTableElement',
  components: {StateTag},
  extends: BasicTableElement,
  props: {
    columns: {type: Array},
    tableData: {type: Object}
  },
  data() {
    return {
      currentRow: undefined,
      rowsSelected: undefined,
      collection: []
    }
  },
  methods: {
    handleRowSelection(selection, row) {
      this.rowsSelected = selection
      this.setRowBackground(_.findIndex(this.collection, row))
      this.$emit('table-selection-change') // selection toggle at the row level
    },
    setRowBackground(index) {
      let rowsObj = this.$el.querySelectorAll('.el-table__row')
      rowsObj[index].classList.toggle('row-checked')
    },
    handleSelectionChange(val) {
      this.rowsSelected = val
      let rowsObj
      // all rows selected
      if (val.length === this.collection.length) {
        rowsObj = this.$el.querySelectorAll('tr.el-table__row:not(.row-checked)')
        this.$emit('table-selection-change') // selection toggle at the header level
      } else if (!val.length) {
        // no rows selected
        rowsObj = this.$el.querySelectorAll('.el-table__row.row-checked')
        this.$emit('table-selection-change') // selection toggle at the header level
      }
      if (rowsObj) {
        rowsObj.forEach(element => {
          element.classList.toggle('row-checked')
        })
      }
    },
    handleHeaderClick(column, event) {
      event.target.style.fontWeight = 'bold'
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/text.css';
@import 'assets/styles/tables.css';

>>> .el-table .row-checked {
  background-color: #e4f3ff;
}

>>> .button2 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/table/MultiSelectTableElement.vue